import { Col, Row } from "antd";
import { FC } from "react";
import {
  Control,
  Controller,
  FieldValues,
  UseFieldArrayRemove,
  UseFormSetValue,
} from "react-hook-form";
import { DeleteIco } from "../../../../modules/assets/icons";
import { AutoComplete } from "../../../../ui-kit";
import styles from "../../DefectForm.module.scss";

export type TAddressDisconnexion = {
  guid: string;
  text: string;
  lat: number;
  lon: number;
};

export const emptyAddressDisconnexion: TAddressDisconnexion = {
  guid: "",
  text: "",
  lat: null,
  lon: null,
};

const AddressDisconnexion: FC<{
  control: Control;
  addressDisconnexion: TAddressDisconnexion;
  index: number;
  setValue: UseFormSetValue<FieldValues>;
  removeAddressDisconnexion: UseFieldArrayRemove;
  required: boolean
}> = ({ control, index, setValue, removeAddressDisconnexion, required }) => {
  const handleOnSelect = async (value: any) => {
    const newAddress: TAddressDisconnexion = {
      guid: value.id,
      text: value.value,
      lat: value.lat,
      lon: value.lon,
    };
    setValue(`addressDisconnexionList.${index}`, newAddress);
  };

  const handleOnChange = async (value: any) => {
    if (!value) {
      setValue(`addressDisconnexionList.${index}`, {
        ...emptyAddressDisconnexion,
      });
    }
  };

  return (
    <Row gutter={22}>
      <Col span={20}>
        <Controller
          control={control}
          name={`addressDisconnexionList.${index}.text`}
          render={({ field }) => (
            <AutoComplete
              field={field}
              label="Адрес"
              onSelect={handleOnSelect}
              onChange={handleOnChange}
              // required={required}
            />
          )}
        />
      </Col>
      <Col span={4}>
        <button
          type="button"
          className={styles.form__blockBtn}
          onClick={(e) => removeAddressDisconnexion(index)}
        >
          <DeleteIco />
        </button>
      </Col>
    </Row>
  );
};

export default AddressDisconnexion;
